/* eslint-disable import/no-anonymous-default-export */
export default {
  MIA_PAYMENT: 'plata cu MIA',
  commentForPicker: 'Comentariu pentru picker',
  howToUsePromocode: 'Cum să folosești un cod promoțional?',
  noPromos: 'Nu ai încă nici un promo cod.',
  noOptions: 'Nu sunt opțiuni',
  hide: 'Ascunde',
  notWorking: 'Nu lucrează',
  chisinauDeliver: 'livrare în Chișinău',
  categoryNotFound: 'În prezent, nu există restaurante disponibile în această categorie!',
  categoryViewOpenedRestaurants: 'Vezi restaurantele deschise',
  cookieConsentTextMob: '🍪 Folosim cookies.',
  cookieConsentText: '🍪 Folosim cookies pentru a îmbunătăți experiența ta de utilizare a site-ului.',
  okay: 'Bine',
  cartSurchargeDescription:
    'Câștigăm din comisionul restaurantului. Dacă suma bonului este mică, aceasta nu acoperă costurile de livrare. Pentru a nu introduce o sumă minimă pentru comandă, aplicăm o mică taxă pentru clienții care plasează o comandă mai mică de 200 lei. Te iubim! 😍',
  smallOrder: 'Taxa pentru comanda mică',
  promoCodeRequired: 'Trebuie să fiți autentificat pentru a utiliza codul promoțional.',
  promoCode: 'Promo cod',
  promoUsageLimit: 'Limita de utilizare',
  promoDetails: 'Detalii',
  promoMinRequirement: 'Cerința minimă',
  promoDiscount: 'Reducere',
  promoRestrictions: 'Restricții',
  promoValidUntil: 'Valabil până la',
  promoCurrency: 'MDL',
  selectRegion: ' depinde de sector. Alegeți sectorul!',
  selectRegionDelivery: 'Prețul pentru livrare',
  showMore: 'Mai mult',
  showLess: 'Mai puțin',
  loginRequired: 'Trebuie să fii autentificat pentru a plasa o comandă.',
  onlyCashPayment: 'Doar cash',
  viewMore: 'toate',
  askForAddress: 'Sunteți sigur că vă aflați la adresa indicată?',
  addAddressTitle: 'Vă rugăm să furnizați adresa de livrare',
  addAddressDescription: 'Ca să te găsească curierul',
  fewRatings: 'Puține recenzii',
  showMapInfo: 'Nu e adresa dvs.?',
  showMap: 'Caută pe hartă',
  address: 'Adresa',
  courier_express: 'Colet',
  markets: 'Magazine',
  restaurants: 'Restaurante',
  closeMaibModalDisclaimer:
    'Dacă închideți fereastra în timpul procesării plății, plata poate să nu fie finalizată cu succes',
  payApplePayGpay: 'Plată Apple/Google',
  paymentMethodTemporarilyDisabled: 'Temporar indisponibil',
  myPromocodes: 'Promocodurile mele',
  each_n_free: 'Fiecare a {0} comandă - livrare gratuită 🚚',
  each_n_free_disclaimer: '🎊 În luna nouă contorul începe de la zero! Profită de avantaj �',
  changeCard: 'Schimbă cardul',
  saveCard: 'Salvează cardul',
  dontSaveCard: 'Nu salva cardul',
  deleteCardInfo: `Ești sigur? Nu puteți anula această acțiune.`,
  deleteCardTitle: 'Ștergeți cardul',
  promoCodeCopied: 'Codul promo a fost copiat cu succes',

  payWithNewCard: 'Achitați cu cardul nou',
  all: 'Toate',
  surchargeBadWeather: 'Suplimentar pentru vreme rea',
  orderDetailsCourierExpressStatus1:
    'Așteptăm confirmarea comenzii de către operator, de obicei durează până la 3 minute ⏳',
  orderDetailsCourierExpressStatus2: 'Curierul știe despre comanda ta și va ridica comanda în cel mai scurt timp 🥷',
  orderDetailsCourierExpressStep2: 'Curând ridicăm comanda',
  orderDetailsCourierExpressStatus3:
    'Curierul a primit coletul, acum nu mai ai mult de așteptat, dorește-i să ajungă la tine fără ambuteiaje 🏎️',
  orderDetailsCourierExpressStep3: 'Curierul a primit coletul',
  orderDetailsCourierExpressStatus4:
    'Eroul tău este deja pe loc, întâmpină-l cu un zâmbet! Se poate și fără flori și mai bine cu "bacșiș" 💶 😁',

  errorCourierExpressComment: 'Vă rugăm să adăugați un comentariu la comandă',
  errorCreatingOrder: 'Eroare la crearea comenzii.',
  orderCreated: 'Comanda creată cu succes',
  whereFrom: 'De unde?',
  whereTo: 'Unde?',
  expressSender: 'Detaliile expeditorului ',
  expressSenderDescription: 'Detalii de unde ridicăm coletul',
  expressReceiver: 'Detaliile destinatarului ',
  expressReceiverDescription: 'Detalii unde livrăm coletul ',
  expressInfoDelivery: 'Informatii despre livrare',
  courierExpressPhotoUpload: 'Atașați o poză',
  courierExpressCommnetHead: 'Descrie ce îți vom livra',
  courierExpressCommnetDescription:
    'Descrie cât mai detaliat posibil ce vom livra și dacă poți atașează o fotografie cu produsul 🛍️',
  courierExpressDescription: 'Vom aduce orice dintr-un punct al orașului tău în altul.',
  courierExpress: 'Livrare colete',
  expressChooseAddresses: 'Selectați Adresele "Către" și "De la"',
  notificationTitle: 'Permite notificări pentru a nu rata reduceri și promoții.',
  welcomeTitle: 'Bine ai venit!',
  welcomeMessage: 'Vă mulțumim că v-ați abonat la notificările noastre.',

  order: 'Comandă',
  soon: 'În curând',
  cartFreeDeliveryInfo: 'și vei primi livrare gratuită la prima comandă! 🎉',
  nameRequired: 'Vă rugăm să adăugați numele',
  invalidEmail: 'Adresă de e-mail nevalidă',
  tooHighNumber: 'Număr prea mare',
  validNumberWithoutDecimals: 'Vă rugăm să introduceți un număr valid fără valori zecimale',
  phoneRequired: 'Este necesar un telefon',
  addressNotSelected: 'Adresa nu este selectată',
  appartament_office: 'Apartament/birou',
  SELECT_CARD: 'Selectați Cardul',
  CARD_REMOVED: 'Card eliminat',
  noCards: 'Nu aveți nici un card adăugat.',
  myCards: 'Cardurile mele',
  addNewCard: 'Adăugați un card nou',
  selectedCardDetails: 'Acesta va fi cardul cu care o să achiți online',
  accountBlockedTitle: 'Notificare urgentă privind contul: contul dvs. este blocat',
  accountBlockedDescription: `Stimate [client_name],

Ne pare rău să vă informăm că contul dvs. de la noi a fost blocat temporar din cauza activității suspecte, a plăților restante.

Vă asigurăm că lucrăm activ pentru a rezolva această problemă cât mai repede posibil. Prioritatea noastră principală este să asigurăm securitatea și integritatea contului dvs. și a oricăror date asociate.

Între timp, dacă aveți întrebări sau nelămuriri urgente, vă rugăm să nu ezitați să contactați asistența noastră pentru clienți. Apreciem înțelegerea și cooperarea dumneavoastră în această problemă.

Cu stimă, Echipa STRAUS`,
  yes: 'Da',
  no: 'Nu',
  nightSurcharge: 'Taxă adițională pentru livrare noaptea\n(de la 00:00 - 06:00)',
  ADULTS_ONLY_CANCEL: `Nu, eu nu am`,
  ADULTS_ONLY_CONFIRM: `Da, continua`,
  СONTAINS_ADULTS_PRODUCTS: `Aici sunt vandute produse pentru cei care deja au implinit virsta de 18 ani. Va rugam sa confirmati acest lucru pentru a continua`,
  ATTACH_FILE: 'Atașează o poză',
  DAILY_SPECIALS: 'Bucatele zilei',
  CATEGORY: 'Categorie',
  ENTER_PHONE_NUMBER: 'Introduceți numarul de telefon',
  PHONE_NUMBER_NOT_VALID: 'Numarul de telefon invalid',
  SMS_WAS_SENT: 'Un SMS cu codul a fost trimis la',
  SMS_CODE_NOT_RECEIVED: 'Nu ați primit codul?',
  BRAND_NEW: 'Nou!',
  MY_DETAILS: 'Detaliile mele',
  MY_ADDRESSES: 'Adresele mele',
  FAVORITES: 'Favorite',
  SUPPORT: 'Serviciul suport clienți',
  LOGOUT: 'Deconectare',
  NEED_HELP: 'Ceva dificultăți? Straus te ajută!',
  ADDED: 'Adăugat',
  ADD: 'Adaugă',
  ADD_TO_CART: 'Adaugă în coș',
  CLEAR_TO_CART: 'Golește coșul',
  CLEAR_TO_CART_DESCRIPTION_PART1: 'Coșul tău conține produse de la ',
  CLEAR_TO_CART_DESCRIPTION_PART2: 'Coșul trebuie golit pentru o comandă nouă',
  ADD_COMMENT: 'Lasă o recenzie',
  DELETED: 'Produsul a fost eliminat',
  DELETE: 'Șterge',
  DELETE_ADDRESS: 'Șterge adresa',
  SAVE_ADDRESS: 'Salvează adresa',
  SAVE: 'Salvează',
  HELLO: 'Salut',
  ARE_YOU_SHURE: 'Ești sigur?',
  LANG: 'Română',
  LANGUAGE_SELECT_TITLE: 'Alege limba',
  ORDERS: 'Comenzi',
  ORDER_EVALUATED: 'Evaluează',
  NOT_FOUND: 'Această pagină nu există',
  NOT_FOUND_MARKET: 'Magazin nu a fost găsit',
  NOT_FOUND_RESTAURANT: 'Restaurant nu a fost găsit',
  NOT_FOUND_CATEGORY: 'Categoria nu a fost găsită',
  NOT_FOUND_PROVIDER_SUBTITLE: 'Alegeți un alt restaurant sau produs',
  NOT_FOUND_SUBTITLE: 'Mai exact, există, dar să știi că pagina de care ai nevoie... nu există! Cerem scuze!',
  SELECT_ADDRESS: 'Selectează adresa',
  ADD_NEW_ADDRESS: 'Adaugă o adresă nouă',
  ADDRESS_REMOVE_SUCCESS: 'Adresa a fost eliminată cu succes',
  ADDRESS_REMOVE_ERROR: 'Eroare la eliminarea adresei',
  ADDRESS_CREATE_ERROR: 'Eroare la crearea adresei',
  ADDRESS_UPDATE_ERROR: 'Eroare la actualizarea adresei',
  ADDRESS_SELECT_ERROR: 'Eroare la selectarea adresei',
  SEARCH: 'Căutare',
  SEARCH_INPUT_FOR_RESTAURANTS: 'Caută în restaurante',
  SEARCH_IN: 'Caută în',
  SEARCH_INPUT_FOR_MARKETS: 'Caută în magazine',
  SEARCH_NOT_FOUND: 'Nici un rezultat găsit',
  SEARCH_RESULTS: 'Rezultatele căutării',
  CURRENCY: 'MDL',
  RESTAURANTS_TITLE: 'Restaurante',
  MOBILE_SIDE_BAR_TITLE: 'Salut',
  RESTAURANT: 'Restaurant',
  MARKET: 'Magazin',
  RESTAURANTS_SUB_TITLE: 'Peste 250 de restaurante',
  SHOPS_TITLE: 'Magazine',
  SHOPS_SUB_TITLE: 'Peste 50 de magazine',
  SHOPS_FIND: 'Magazine găsite',
  EXPRESS_COURIER: 'Comandă Curier',
  EXPRESS_COURIER_SUB_TITLE: 'Disponibil în aplicația mobilă ',
  COURIER_NAME: 'Curier',
  CATEGORY_TITLE: 'Ce dorești astăzi',
  RESTAURANT_CATEGORY: 'Categorie în restaurant',
  DOWNLOAD_THE_APPLICATION: 'Descarcă aplicația',
  DOWNLOAD_THE_APPLICATION_SUB_TITLE: 'Prin aplicație este mai ușor să faci comandă, ne pasă de timpul tău!',
  INFORMATION: 'Informație',
  INFORMATION_SUB_TITLE_FOR_US: 'Despre noi',
  INFORMATION_SUB_TITLE_PARTNERS: 'Devino partener Straus',
  INFORMATION_SUB_TITLE_CAREERS: 'Devino angajat Straus',
  GENERAL: 'General',
  GENERAL_TEAMS: 'Termeni și condiții',
  GENERAL_PROCESSING_PERSONAL_DATA: 'Prelucrarea datelor cu caracter personal',
  ERROR_UPDATE_DATA: 'Eroare la actualizarea datelor',
  SUCCESS_UPDATE_DATA: 'Datele au fost actualizate cu succes',
  CONTACT: 'Contacte',
  FOLLOW_US_ON: 'Urmărește-ne pe',
  VIEW_ALL: 'Vezi toate',
  PROMOTION_TITLE: 'Promoții și reduceri',
  RECOMMENDED_RESTAURANTS: 'Restaurante recomandate',
  TOP_RESTAURANTS: 'Straus recomandă',
  NEW_RESTAURANTS_ON_STRAUS: 'Nou săptămâna aceasta',
  SORT_RECOMMENDED: 'Recomandăm',
  SORT_ONLINE_PAYMENT: 'Cu plată online',
  SORT_BY: 'Sortează după',
  FILTER_TITLE: 'Filtre',
  FILTERS_MORE: 'Mai multe filtre',
  FILTER_RESET: 'Resetează',
  RESTAURANTS_FIND: 'de restaurante găsite',
  FILTER_BY_CATEGORY: 'Ce dorești astăzi?',
  FILTER_BY_BENEFITS: 'Arată de la început',
  SOMETHING_WENT_WRONG: 'Ceva nu a mers bine',
  DETAILS: 'Detalii',
  DETAILS_PROVIDER: 'Detalii',
  DELIVERY_TIME: 'Timp de livrare',
  DELIVERY_TERMS: 'Condiții de livrare',
  DELIVERY_METHOD: 'Când să livrăm?', // Metoda de livrare
  DELIVERY_ZONE: 'Zona de livrare',
  PAYMENT_METHOD: 'Metoda de plată',
  FAVOURITE: 'Favorite',
  FAVOURITE_ADD: 'Adăugat la favorite',
  ERROR_FAVOURITE_ADD: 'Eroare la adăuga la favorite',
  FAVOURITE_REMOVE: 'Eliminat din favorite',
  ERROR_FAVOURITE_REMOVE: 'Eroare la elimina din favorite',
  FAVOURITE_IS_EMPTY: 'Încă nu ai favorite',
  EMPTY_FAVORITES: 'Încă nu ai favorite',
  DELIVERY: 'Livrare',
  DELIVERY_FROM: 'Livrare de la',
  MINUTES: 'min',
  CLOSING_PROVIDER: 'Se închide la',
  WILL_OPEN_PROVIDER: 'Se va deschide la',
  WILL_OPEN_TOMORROW_PROVIDER: 'Se va deschide mâine la',
  WILL_OPEN_TODAY_PROVIDER: 'Se va deschide astăzi la',
  TODAY: 'Astăzi la',
  TOMORROW: 'Mâine la',
  CLOSING_PROVIDER_DESCRIPTION:
    'momentan închis, ai posibilitatea să faci o comandă prealabilă sau să vezi alte restaurante deschise',
  PAUSE_PROVIDER_DESCRIPTION:
    'În acest moment livrăm doar din cele mai apropiate restaurante de tine, dar %providerName% este puțin departe. Nu te supăra ❤️, alege altul - mai aproape de tine.',
  PAUSE_PROVIDER_DESCRIPTION_PS:
    'P.S. Prietenește spune-ne , poate ai prieteni care doresc să încerce rolul de curier, recomandă-ne. Îmbrățișare 🤗',
  PAUSE: 'Pauză',
  PAUSE_UNTIL: 'Pauză până la',
  OVERLOADED: 'Supraîncărcat',
  OVERLOADED_TO: 'Supraîncărcat până la ',
  AVAILABLE: 'Disponibile',
  CONTINUE_HERE: 'Сontinuă',
  OPEN_PROVIDER: 'Vezi deschise',
  OPEN_PROVIDER_IN: 'se va deschide la ',
  PROVIDER_NO_REVIEWS: 'nici o recenzie încă',
  REVIEW: 'Recenzii',
  SUCCESS_SEND_REVIEW: 'Recenzia ta a fost trimisă cu succes, mulțumesc!',
  ERROR_SEND_REVIEW: 'Eroare la trimiterea recenziei!',
  PRODUCTS: 'Produse',
  ADD_MORE_PRODUCTS: 'Comandă încă de',
  SHOW_MORE_PROVIDERS: 'Afișează mai multe',
  ADD_MORE_PRODUCTS_DESCRIPTION: 'și îți oferim o reducere de',
  ADD_MORE_PRODUCTS_DESCRIPTION_FREE: 'și livrarea va fi GRATUITĂ! 🆓',
  ORDERED_PRODUCTS: 'produse comandate',
  ORDER_CREATE_ERROR: 'Eroare la crearea comenzii',
  MY_ORDERS: 'Comenzile mele',
  DISCOUNT: 'Reducere',
  APPLY: 'Aplică',
  FREE: 'Livrare gratuită',
  ADDRESSES_IN_CHISINAU: 'Adresă în Chișinău:',
  WORK_PROGRAM_TODAY: 'Program de lucru',
  CHAT: 'Chat',
  SOUNDS: 'Sună',
  YOUR_ORDER: 'Comanda ta',
  NEXT_STEP: 'Pasul următor',
  CART: 'Coș',
  CART_EMPTY: 'Coșul gol',
  GO_TO_CART: 'Mergi la coș',
  CUTLERY: 'Tacâmuri',
  CUTLERY_DESCRIPTION: 'Împreună cu Straus ajutăm planeta, comandă tacâmuri doar dacă nu dispui de ele.',
  COMPLETE_ORDER: 'Încă ceva?',
  SPECIAL_MENTIONS: 'Mențiuni speciale',
  ADD_SPECIAL_MENTIONS: 'Puteți adăuga un comentariu',
  ORDER_SUMMARY: 'Total comandă',
  ORDER_DELIVERED: 'Comandă livrată',
  TOTAL_PRODUCTS: 'Total Produse',
  TOTAL_ORDER: 'Spre achitare',
  ORDER_COMPLETION: 'Finalizare comandă',
  ORDER_DETAILS: 'Detalii comandă',
  ORDER_STATUS_HERE: 'Detalii comandă aici',
  ORDER_CANCEL: 'Anulează comanda',
  ORDER_CANCEL_DESCRIPTION: 'Pentru a anula comanda, vă rugăm să indicați un motiv.',
  ORDER_CANCELED: 'Această comandă a fost anulată.',
  ORDER_SEND: 'Plasează comanda',
  ORDER_NUMBER: 'Numărul comenzii',
  ORDER_LOADING: 'Se încarcă comanda',
  EVALUATE_ORDER: 'Evaluează comanda',
  CHECKOUT: 'Verifică',
  PRE_ORDER_SUB_TITLE: 'Apăsând pe buton puteți plasa o comandă prealabilă',
  PRE_ORDER_REQUIRED: 'Este necesar o comandă prealabilă',
  ADD_PRE_ORDER: 'Precomandă',
  NO_PRE_ORDER: 'Precomanda nu este disponibilă.',
  SELECT_TIME_AND_DAY: 'Selectează ora',
  SELECT: 'Selectează',
  SELECT_MAX_OPTIONS: 'Selectează maximum',
  SELECT_OPTIONS: 'Selectează optiuni',
  OPTIONS: 'Opțiune',
  CANCEL: 'Anulare',
  DELIVERY_TO_ADDRESS: 'Livrare la adresa',
  DELIVERY_COST_INFO_TITLE: 'Cât costă livrarea?',
  DELIVERY_COST_INFO_DESCRIPTION_PART1:
    'Prețul livrării variază în dependență de distanță - cu cât distanța pe care ' +
    'o parcurge curierul nostru este mai mică, cu atât prețul livrării este mai mic. ' +
    'Achitarea adițională în valoare de 20 lei se aplică pentru adresele din sectoarele' +
    'îndepărtate.',
  DELIVERY_COST_INFO_DESCRIPTION_PART2:
    'Când plasați comanda în unul din localuri, vedeți suma totală pentru livrare ' +
    'până când comanda se confirmă. Prețul de bază pentru livrare depinde de înțelegerea ' +
    'noastră cu localul din care ați făcut comanda. Pentru a afla prețul de bază pentru ' +
    'livrare, apăsați pe imaginea localului, iar în partea de sus a paginii veți găsi ' +
    'indicat valoarea livrării. Spre exemplu: "Livrare de la 39 lei" - în așa fel veți ' +
    'cunoaște suma totală spre plată până la momentul confirmării comenzii.',
  PERSONAL_LIFT: 'Ridicare personală (În curând)',
  HOME: 'Acasă',
  I_WORK_HERE: 'Livrează aici',
  OFFICE: 'Birou',
  UNTITLED: 'Fară nume',
  ADDRESS_DETAILS: 'Adresa de livrare',
  ADDRESS_APT_OFFICE: '№ Apt./Oficiu',
  INTER_PHONE: 'Interfon',
  USER_PHONE_NUMBER: 'Număr de telefon',
  USER_PHONE_NUMBER_DESCRIPTION: 'Vom ține legătura la acest număr de telefon',
  STAIRS: 'Scara',
  FLOOR: 'Etaj',
  ADDRESS_PRIVATE_HOUSE: 'Casă privată',
  CHANGE_ADDRESS: 'Salvează adresa',
  FORCE_CHANGE_ADDRESS: 'Schimba adresa',
  ALERT_CHANGE_ADDRESS: 'Atenţie! Incerci să îți schimbi adresa de livrare.',
  ALERT_CHANGE_ADDRESS_MESSAGE: 'Dacă îți schimbi adresa de livrare, coșul tău va fi golit. Ștergem adresa curentă?',
  ONLINE_CARD_PAYMENT: 'Plată cu card online',
  ONLINE_CARD_PAYMENT_MESSAGE: 'Plata cu cardul se face pe pagina băncii, noi nu salvăm datele tale',
  CASH_PAYMENT_ON: 'Plată cash la livrare',
  USER_NAME: 'Nume',
  USER_NAME_PLACEHOLDER: 'Numele tău',
  USER_AGREEMENT: 'Termeni de utilizare',
  USER_NAME_AND_SURNAME: 'Cum ți-ar plăcea să ne adresăm?',
  USER_NAME_DESCRIPTION: 'Acceptăm și nickname ',
  EMAIL_PLACEHOLDER: 'Poștă electronică',
  EMAIL_DESCRIPTION: 'La această poștă trimitem bon-uri și scrisori, sper că ai acces la ea',
  ADD_VOUCHER: 'Adaugă promo codul',
  ADD_VOUCHER_PLACEHOLDER: 'Scrie aici promo codul',
  VOUCHER_TITLE: 'Ai un promo cod?',
  VOUCHER: 'Promo cod',
  VOUCHER_DESCRIPTION: 'Introduce un promo cod nou, sau alege unul din lista ta.',
  ORDER_STATUS_AUTO_CONFIRMED: 'Comanda a fost confirmată automat',
  ORDER_STATUS_4: 'Curierul este lângă adresă, nu a mai rămas mult',
  ORDER_STATUS_DELIVERED: 'Comandă livrată',
  YOU_HAVE_NO_ORDERS: 'Încă nu ai nici o comandă',
  DURATION_ORDER_TITLE: 'Comanda va fi livrată aproximativ la',
  HELP: 'Ajutor',
  LOGIN_TITLE: 'Autentificare',
  CLEAR_CART_TITLE: 'Ești sigur că dorești să golești coșul?',
  CLEAR: 'Golește',
  CLEAR_CART_DESCRIPTION: 'Coșul trebuie golit, pentru o comandă nouă',
  ADDING_PRODUCT_FROM_ANOTHER_RESTAURANT_TITLE: 'Golim coșul? ',
  LEAVE_PRODUCTS: 'Păstrează produsele',
  RESTAURANT_NEARBY: 'Restaurante în apropiere',
  RESTAURANT_POPULAR: 'Restaurante populare',
  PREORDER: 'Comandă în prealabil',
  COMPLETE_ALL_FIELDS: 'Completează toate câmpurile',
  FIELD_IS_REQUIRED: 'Câmpul este obligatoriu',
  IS_REQUIRED: 'Obligatoriu',
  THIS_FIELD_IS_TOO_LONG: 'Acest câmp nu poate fi atât de lung',
  GO_TO_MAIN_PAGE: ' La pagina principală',
  TO_PLAN: 'Programează pentru',
  PAY_ORDER: 'Achită comanda',
  ORDER_IS_PAID: 'Comanda a fost achitată',
  ORDER_FOR_SELF_TITLE: 'Comand pentru mine',
  ERROR_ORDER_IS_PAID: 'Eroare de plată pentru această comandă',
  RECOMMENDED_PRODUCT: 'Recomandăm',
  RECIPIENT_DATA: 'Datele destinatarului',
  POLICY_PART_1: 'Am citit și sunt de acord cu',
  POLICY_PART_2: 'Acordul Utilizatorului',
  POLICY_PART_3: 'și sunt de acord cu prelucrarea informațiilor mele personale în conformitate cu termenii',
  POLICY_PART_4: 'Politica de Confidențialitate',
  BASE_DELIVERY_TIME: 'Livrare medie 50 minute',
  DELIVERY_DETAILS_DESCRIPTION:
    'Costul și timpul mediu de livrare le poți găsi pe pagina restaurantului care te interesează. ' +
    'Timpul de livrare va fi redus dacă adresa ta de livrare se află în aceeași zonă cu adresa restaurantului. ' +
    'Livrăm comenzi în zona specificată pe hartă. Dacă adresa ta se află în afara zonei specificate, verifică ' +
    'costul, ora și posibilitatea de livrare în acest moment la operatorii noștri. ' +
    'Adresează întrebările în chat sau sună la 0(22)899-999',
  ABOUT_US_TITLE: 'Pentru ce suntem?',
  ABOUT_US_DESCRIPTION:
    'Straus - cel mai bun serviciu de livrare a produselor din restaurante și magazine! ' +
    'Ai acces la meniul a zeci de restaurante și, de asemenea, te poți familiariza cu ratingul și ofertele speciale ale acestora. ' +
    'Apreciem timpul tău, de aceea dorim să-ți oferim oportunitatea de a plasa comanda ușor și simplu, iar echipa noastră o va livra acasă, la birou sau în oricare alt punct al orașului ' +
    'la birou sau oriunde în oraș în cel mai scurt timp posibil. Meniul nostru conține peste 250 restaurante, cafenele, pizzerii, sushi baruri și pub-uri. ' +
    'Cu echipa STRAUS - nu rămâi flămând niciodată!',
  CONTACT_US: 'Contactează-ne',
  CLOSE_PROVIDER: 'Închis',
  TEMP_CLOSE_PROVIDER: 'Închis temporar',
  TODAY_IN: 'astăzi la',
  TOMORROW_IN: 'Mâine la',
  SCHEDULE_FOR: 'program pentru',
  ORDER_STATUS_1_NEW_ORDER_FOR_RESTAURANT:
    'Asteptam confirmarea comenzii de restaurant, de obicei durează până la 3 minute ⏳',
  ORDER_STATUS_1_NEW_ORDER_FOR_MARKET:
    'Așteptăm confirmarea comenzii de magazin, durează de obicei până la 3 minute ⏳',
  ORDER_STATUS_2_FOR_RESTAURANT:
    'Restaurantul a confirmat comanda și a început să pregătească gustoșeniile tale  🧑‍🍳, numai dacă nu ai făcut o comandă prealabilă',
  ORDER_STATUS_2_FOR_MARKET:
    'Magazinul a confirmat comanda și a început să o asambleze 🛍️, desigur dacă nu este o comandă prealabilă.',
  ORDER_STATUS_3_RESTAURANT: 'Curierul este deja în restaurant, așteaptă ridicarea comenzii  🥷',
  ORDER_STATUS_3_MARKET: 'Curierul este deja în market, așteaptă ridicarea comenzii  🥷',
  COURIER_RIDES:
    'Curierului i s-a dat comanda, acum nu mai e mult de asteptat, ureza-i sa ajunga acolo fara ambuteiaje 🏎️',
  CALL_US: 'Anunțați-ne dacă aveți probleme cu livrarea',
  COURIER_SLOGAN: 'Voi veni la tine cât mai curând posibil',
  COURIER_NUMBER_PHONE: 'Numar de curier',
  ADDRESS_OFFICE: 'Chișinău, Teatrul 15B',
  RESTAURANT_DELIVERING:
    'Restaurantul a confirmat comanda și a început să pregătească gustoșeniile tale 🧑‍🍳, numai dacă nu ai făcut o comandă prealabilă. Poftă bună și nu uita să evaluezi comanda! \n' +
    ' ⚠️ Comanda va fi livrată de curierul restaurantului, nu vei putea urmări starea comenzii aici.  Pentru orice intrebari despre comanda, sună-ne, te ajutăm!',
  NO_RESULTS_SEARCH_ADDRESS: 'Nu există Rezultate',
  SEARCH_ADDRESS_PLACEHOLDER: 'Strada și numarul',
  YOU_HAVE_18_YEARS: 'Ai deja 18 ani',
  NOT_FAVOURITES: 'Nu ai favorite',
  ACTIVE_ORDERS: 'Comenzi active',
  MY_DATA: 'Detaliile mele',
  PLEASE_CHECK_POLICY: 'Vă rugăm să verificați politica',
  RECIPIENT_DATA_REQUIRED: 'sunt necesare detaliile destinatarului',
  YOUR_CART_IS_EMPTY: 'Coșul tău este gol',
  EVALUATE_ORDER_RATE_FORM_TITLE: 'Cum au fost produsele de la ',
  EVALUATE_COURIER_RATE_FORM_TITLE: 'Cum iti place livrarea facuta ',
  FOR_ADULT: '18+',
  BANNER_REDIRECT_ON_MOBILE_APP_TITLE: 'Straus are o aplicație mobilă grozavă',
  DOWNLOAD_MOBILE_APP: 'Descărcați aplicația mobilă',
  STOP_RUN_SITE:
    'Salut, prietene!' +
    'Au loc lucrări de întreținere a site-ului , te rugăm să plasezi comanda în aplicația mobilă Straus. Scuze pentru incomodități.',
  PRESENTATION_IMAGE_WARNING: 'Produsele din imagine sunt cu titlu de prezentare',
  WEIGHTED: 'Produs la greutate',
  NON_STOP: 'Non-stop',
  LIKE: 'Da mi-a placut!',
  DISLIKE: 'Nu-mi place!',
  WHAT_CAN_IMPROVE: 'Ce poate îmbunătăți?',
  FAR_AREA_SURCHARGE: 'Plată pentru zonă îndepărtată',
  LOCATION_OUTSIDE_DELIVERY: 'Adresă în afara zonei livrate',
  LOCATION_SEARCH_ERROR: 'Eroare de căutare a adresei. Mai incercă',
  GEOLOCATION_NOT_SUPPORTED: 'Geolocalizarea nu este acceptată',
  REQUIRE_GEOLOCATION_PERMISSIONS: 'Necesită permisiuni de localizare geografică',
  INGREDIENTS: 'Ingrediente',
  STORAGE_INSTRUCTIONS: 'Condiții de depozitare',
  BRAND: 'Marca',
  COUNTRY_OF_ORIGIN: 'Producător',
  WILL_BE_USEFUL: 'Va fi util',
  FREE_DELIVERY_PROMO_CONFLICT_TITLE: 'Codul promoțional va anula livrarea gratuită',
  FREE_DELIVERY_PROMO_CONFLICT_TEXT: 'Dacă folosești un cod promoțional, livrarea gratuită nu se va aplica.',
  //Metro
  MAIN: 'Principal',
  PRICE: 'Preț',
  DEFAULT: 'În mod implicit',
  CHEAP: 'Ieftine',
  EXPENSIVE: 'Scumpe',
  CONTINUE: 'Continua',
  FILTERS: 'Filtre',
  TRADEMARK: 'Marcă comercială',
  COUNTRY: 'Țară',
  PURPOSE: 'Scop',
  AMOUNT: 'Cantitate',
  PROFITABLE_SHELF: 'Reduceri și promoții',
  PRODUCT_CATEGORIES: 'Categorii de produse',
  NOT_AVAILABLE: 'Nu este disponibil',
  CATEGORIES: 'Categorii',
  PCS: 'buc',
  KG: 'kg',
  ALPHABETICALLY_A_Z: 'De la A la Z',
  ALPHABETICALLY_Z_A: 'De la Z la A',
  IS_NEW: 'Noi',
  ONLY_IN_STOCK: 'Doar în stoc',
  BACK: 'Înapoi',
  CLEAR_FILTERS: 'Șterge filtrele',
  CLOSE: 'Închideți',
  PROMOTIONAL_ITEMS: 'Articole promoționale',
  SHOW_ALL: 'Arată tot',
  FAVORITE_PRODUCTS: 'Favorite produse',
};
